import angular from 'angular';
import moment from 'moment';
import { ITrabalhador } from '../models/trabalhador.model';
import {
    ITrabalhadorListItem,
    ITrabalhadoresListFilter,
    ITrabalhadoresReturnContext
} from './models/trabalhadores.index.model';
import { TrabalhadoresService } from '../trabalhadores.service';
import { ListagemService } from '../../../shared/services/listagem.service';
import { RelatoriosService } from '../../../shared/services/relatorios.service';
import { Empresa, Estabelecimento, Usuario } from '../../../core/usuario/models/usuario-model';

export class TrabalhadoresListController implements angular.IController {
    static $inject = ['$rootScope', '$scope', '$state', '$stateParams', 'NewToaster', 'TrabalhadoresService', 'RelatoriosService', '$filter', 'BuscaAvancadaService', 'ListagemService'];

    public entity: Partial<ITrabalhador>;
    public entities: ITrabalhadorListItem[] = [];
    public busy = false;
    public carregandoRelatorio = false;
    public entitiesSelecionadas: ITrabalhadorListItem[] = [];
    public trabalhadorinput = '';
    public entitiesTrabalhadores: ITrabalhadorListItem[];
    public entitySearchList: ITrabalhadorListItem[] = [];
    public dataFinal: string | moment.Moment = moment().endOf('month').format('YYYY-MM-DD');
    public dataInicial: string | Date = new Date();
    public primeiroLookupTrabalhadoresCarregado = false;
    public checkboxTodos = false;
    public checkboxNenhum = true;
    public filter: any = {};
    public filters: ITrabalhadoresListFilter = {};
    public empresas: Empresa[];
    public estabelecimentos: Estabelecimento[];
    public listagemPermissao: string[] = ['visualizar_funcionarios', 'relatorios_fichascadastrais'];
    public permissaoGrupoEmpresarial = false;
    public lookupTrabalhadores = false;
    public checkAll: boolean;
    public fields = [
        {
            value: 'status',
            label: 'Situação',
            type: 'string',
            style: 'label',
            copy: '',
            label_class: '{ "label-warning": entity.situacao === 0, "label-success": entity.situacao === 1, "label-danger": entity.situacao === 2 }',
        },

        {
            value: 'codigo',
            label: 'Código',
            type: 'string',
            style: 'title',
            copy: '',
        },

        {
            value: 'nome',
            label: 'Nome',
            type: 'string',
            style: 'default',
            copy: '',
        },

        {
            value: 'cpf',
            label: 'CPF',
            type: 'string',
            style: 'default',
            copy: '',
        },

        {
            value: 'dataadmissao',
            label: 'Data admissão',
            type: 'date',
            style: 'default',
            copy: '',
        },

        {
            value: 'datarescisao',
            label: 'Data rescisão',
            type: 'date',
            style: 'default',
            copy: '',
        },

        {
            value: 'datavencimentoatestadomedico',
            label: 'datavencimentoatestadomedico',
            type: 'datetime',
            style: 'default',
            copy: '',
        },

        {
            value: 'categoriatrabalhador',
            label: 'CategoriaTrabalhador',
            type: 'string',
            style: 'default',
            copy: '',
        },

    ];

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            modoGestorPermissao: (arg: string) => boolean,
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            session: any,
            nsjGlobals: any,
            usuario: Usuario
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public NewToaster: {
            pop: (opts: { type: string; title: string; body?: string }) => void;
        },
        public entityService: TrabalhadoresService,
        public RelatoriosService: RelatoriosService,
        public $filter: angular.IFilterFunction,
        public BuscaAvancadaService: any,
        public ListagemService: ListagemService,
    ) {
        this.resetEntityServiceState();

        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

        this.hydrateDefaults();
        this.hydrateFromReturnContext();
        this.applyFiltersToService();

        if (!this.$rootScope.temPermissao('visualizar_funcionarios') || !this.$rootScope.temPermissao('relatorios_fichascadastrais')) {
            $state.go('dp', $stateParams);
        }

        this.$rootScope.$on('persona_trabalhadores_list_finished', (event: angular.IAngularEvent, args: any): void => {
            this.entitySearchList = [...args] as ITrabalhadorListItem[];
            for (let i = 0; i < this.entitySearchList.length; i++) {
                this.entitySearchList[i]['tipoFiltrado'] = $filter('lookupTipoTrabalhador')(this.entitySearchList[i]['tipo']);
            }
        });

        this.$rootScope.$on('Trabalhadores_loading', (event: angular.IAngularEvent, args): void => {
            if (!this.primeiroLookupTrabalhadoresCarregado) {
                this.lookupTrabalhadores = true;
                this.primeiroLookupTrabalhadoresCarregado = true;
            }
        });

        $rootScope.$on('Trabalhadores_loaded', (event: angular.IAngularEvent, args: any): void => {
            this.lookupTrabalhadores = false;
        });

        $scope.$on('trabalhadores_deleted', (event: angular.IAngularEvent): void => {
            this.entityService.reload();
        });

        $scope.$on('$destroy', (): void => {
            if (this.entityService.loading_deferred) {
                this.entityService.loading_deferred.resolve();
            }

            this.entityService.constructors = {};
            this.entityService.filters = {};
            this.entityService.filter = '';
        });

        $rootScope.$on('trabalhadores_submitted', (event: angular.IAngularEvent, args: any): void => {
            if (!args.autosave) {
                this.entityService.reload();
            }
        });
    }

    $onInit() {
        this.entity = {};
    }

    getShowStateParams(trabalhador: string): { trabalhador: string; returnState: string; returnContext: ITrabalhadoresReturnContext } {
        return {
            trabalhador,
            returnState: this.$state.current.name || 'trabalhadores',
            returnContext: this.buildReturnContext()
        };
    }

    goToShow(trabalhador: string): void {
        this.$state.go('trabalhadores_show', this.getShowStateParams(trabalhador));
    }

    montaListagemVisibilidade() {
        this.filters.empresa = this.$rootScope.session.entities.empresa.empresa;
        this.filters.estabelecimento = this.$rootScope.session.entities.estabelecimento.estabelecimento;
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        this.limpaNsjSearch('trabalhador');
        this.resetFiltroLotacao(false);
        this.$rootScope.$broadcast('lotacao_refresh', this.constructorLotacao());
        this.refreshList();
    }

    carregandoLookups(): boolean {
        return this.lookupTrabalhadores;
    }

    buscaAvancada(): void {
        this.entityService.constructors.tipo = this.filters.tipo;
        delete this.entityService.constructors.trabalhador;

        let columns = ['Nome', 'Tipo'];
        let values = ['nome', 'tipo'];
        let enumValues: any = [];
        enumValues['nome'] = '';
        enumValues['tipo'] = 'lookupTipoTrabalhador';
        this.entityService.constructors['status'] = '00';
        let modal = this.BuscaAvancadaService.open(this, this.filters, this.entityService, columns, values, 'Colaboradores', enumValues, 'trabalhador', true, false, true, () => this.filtraTrabalhador());
        modal.result.then(() => {/* */}).catch(() => {/* */});
    }

    evento(event: angular.IAngularEvent & { detail: any }): void {
        this.filter.search = event.detail.value;
        this.search();
    }

    comboBusy(): boolean {
        return this.entityService.loadParams.busy;
    }

    limpaNsjSearch(id: string): void {
        document.querySelectorAll(`#${id} .componentPosition .customIcon`)[0]?.dispatchEvent(new Event('click'));
        document.querySelectorAll(`#${id} .componentPosition .customIconMobile`)[0]?.dispatchEvent(new Event('click'));
    }

    retornaListagemCombo(): ITrabalhadorListItem[] {
        return this.entitySearchList;
    }

    search(): ITrabalhadorListItem[] {
        return this.refreshList();
    }

    loadMore(): void {
        this.entityService.loadMore();
    }

    finished(): boolean {
        return this.entityService.loadParams.finished;
    }

    isBusy(): boolean {
        return this.entityService.loadParams.busy;
    }

    searchRelatorios(): void {
        this.refreshList();
    }

    reload(): void {
        this.refreshList();
    }

    semGeridos(): boolean {
        if (this.$rootScope.modoGestorPermissao('visualizar_funcionarios')) {
            let semGeridos = this.$rootScope.nsjGlobals.get('semGeridos');
            let semGeridosAtivos = this.$rootScope.nsjGlobals.get('semGeridosAtivos');

            return semGeridos || semGeridosAtivos;
        }

        return false;
    }

    visualizarFichaCadastral(trabalhador: string | null = null): void {
        this.carregandoRelatorio = true;
        let ids: any = [];

        if (trabalhador) {
            ids.push(trabalhador);
        } else {
            this.entities.forEach((entity): void => {
                if (entity.selecionado) {
                    ids.push(entity.trabalhador);
                }
            });
        }

        if (ids.length > 0) {
            let constructor = { 'trabalhadores': ids, 'id': 'null' };
            let callback = (): void => {
                this.carregandoRelatorio = false;
            };

            this.RelatoriosService.abrirRelatorioFop('persona_trabalhadores_ficha', constructor, callback, false);
        }
    }

    visualizarFichaCadastralIndividual(id: string): void {
        this.carregandoRelatorio = true;
        let ids: any = id !== null ? [id] : [];

        if (ids.length > 0) {
            let constructor = { 'trabalhadores': ids, 'id': 'null' };
            let callback = (): void => {
                this.carregandoRelatorio = false;
            };

            this.RelatoriosService.abrirRelatorioFop('persona_trabalhadores_ficha', constructor, callback, false);
        }
    }

    baixarFichaCadastral(): void {
        this.carregandoRelatorio = true;
        let ids: any = [];

        angular.forEach(this.entities, (entity): void => {
            if (entity.selecionado) {
                ids.push(entity.trabalhador);
            }
        });

        if (ids.length > 0) {
            let constructor = {
                'trabalhadores': ids,
                'id': 'null',
                'empresa': this.filters.empresa,
                'estabelecimento': this.filters.estabelecimento
            };
            let callback = (): void => {
                this.carregandoRelatorio = false;
            };
            this.RelatoriosService.baixarRelatorioFop(
                'persona_trabalhadores_ficha',
                constructor,
                callback,
                false,
                'ficha_cadastral_trabalhadores.pdf'
            );
        }
    }

    checkboxEntidades(acao: any = null): void {
        this.entities.forEach((entity): void => {
            if (acao === null) {
                entity.selecionado = this.checkboxTodos ? true : false;
            } else {
                entity.selecionado = acao;
            }
        });

        if (acao !== null) {
            this.checkboxTodos = acao ? true : false;
        }
        this.checkboxNenhum = this.checkboxTodos ? false : true;
    }

    renovaCheckbox(): void {
        this.checkboxNenhum = true;
        this.checkboxTodos = false;
    }

    quantidadeFuncionariosSelecionados(): number {
        let qtd = 0;

        this.entities.forEach((entity): void => {
            if (entity.selecionado) {
                qtd++;
            }
        });

        return qtd;
    }

    todosFuncionariosSelecionados(): void {
        let selecionado = true;

        if (this.entities.length === 0) {
            selecionado = false;
        }

        this.entities.forEach((entity): void => {
            if (!entity.selecionado) {
                selecionado = false;
            }
        });

        this.checkboxTodos = selecionado;
    }

    nenhumFuncionarioSelecionado(): void {
        let nenhumSelecionado = true;

        this.entities.forEach((entity): void => {
            if (entity.selecionado) {
                nenhumSelecionado = false;
            }
        });

        this.checkboxNenhum = nenhumSelecionado;
    }

    resetFiltroTrabalhador(syncStateParams: boolean = true) {
        this.filters.trabalhador = null;
        this.trabalhadorinput = '';

        if (syncStateParams) {
            this.refreshList();
        }
    }

    resetFiltroLotacao(syncStateParams: boolean = true) {
        this.filters.lotacao = null;

        if (syncStateParams) {
            this.refreshList();
        }
    }

    filtraTrabalhador(eventoTrabalhador: { detail: {value: ITrabalhadorListItem} } | null = null) {
        if (eventoTrabalhador) {
            this.filters.trabalhador = eventoTrabalhador.detail.value;
        }

        this.refreshList();
    }

    filtraStatus() {
        this.refreshList();
    }

    filtraTipo() {
        this.refreshList();
    }

    filtraLotacao() {
        this.refreshList();
    }

    constructorLotacao() {
        return {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento
        };
    }

    relatorioPonto(action: any): void {
        this.carregandoRelatorio = true;
        let ids: any = [];

        this.entitiesSelecionadas.forEach((entity): void => {
            ids.push(entity.trabalhador);
        });

        if (ids.length > 0 && this.validarPeriodoRelatorioPonto()) {
            let constructor = {
                'trabalhadores': ids,
                'dataInicial': this.dataInicial,
                'dataFinal': this.dataFinal,
                'empresa': this.filters.empresa,
                'estabelecimento': this.filters.estabelecimento
            };
            let callback = (): void => {
                this.carregandoRelatorio = false;
            };
            action === 'view'
                ? this.RelatoriosService.abrirRelatorioFop('persona_trabalhadores_ponto', constructor, callback, false)
                : this.RelatoriosService.baixarRelatorioFop(
                    'persona_trabalhadores_ponto',
                    constructor,
                    callback,
                    false,
                    this.getFolhasPontoDownloadFileName()
                );
        } else {
            if (ids.length <= 0) {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Pelo menos um trabalhador precisa ser selecionado'
                });
            }

            this.carregandoRelatorio = false;
        }
    }

    selecionaTrabalhador() {
        if (this.filters.trabalhador?.trabalhador) {
            let naoSelecionado = !this.entitiesSelecionadas.some((trabalhador: any) => trabalhador.trabalhador === this.filters.trabalhador?.trabalhador);

            if (naoSelecionado) {
                this.entitiesSelecionadas = [];
                this.entitiesSelecionadas.push(this.filters.trabalhador as ITrabalhadorListItem);
            }
        }

        let index = this.entities.findIndex(
            trabalhador => trabalhador.trabalhador === this.filters.trabalhador?.trabalhador
        );

        if (index > -1) {
            this.entities[index].check = true;
        }

        delete this.filters.trabalhador;
    }

    adicionarRemoverListaSelecionados(entity: ITrabalhadorListItem[]): void {
        entity.forEach((entity) => {
            if (entity.selecionado) {
                let naoSelecionado = !this.entitiesSelecionadas.some(
                    trabalhador => trabalhador.trabalhador === entity.trabalhador
                );

                if (naoSelecionado) {
                    this.entitiesSelecionadas.push(entity);
                }
            } else {
                let index = this.entitiesSelecionadas.findIndex(
                    trabalhador => trabalhador.trabalhador === entity.trabalhador
                );

                if (index > -1) {
                    this.entitiesSelecionadas.splice(index, 1);
                    this.checkAll = false;
                }
            }
        });
    }

    removerSelecionado(k: number): void {
        let guid = this.entitiesSelecionadas[k].trabalhador;
        this.entitiesSelecionadas[k].selecionado = false;
        this.checkboxTodos = false;

        this.entitiesSelecionadas.splice(k, 1);

        let index = this.entities.findIndex(
            trabalhador => trabalhador.trabalhador === guid
        );

        if (index > -1) {
            this.entities[index].check = false;
            this.checkAll =  false;
        }
    }

    exportarPdfTodosTrabalhadores(empresa: string, estabelecimento: string, tipoTrabalhador: string, status: string) {
        if (!this.validarPeriodoRelatorioPonto()) {
            return;
        }

        this.carregandoRelatorio = true;

        let callback = (): void => {
            this.carregandoRelatorio = false;
        };

        let constructor = {
            'dataInicial': this.dataInicial,
            'dataFinal': this.dataFinal,
            empresa,
            estabelecimento,
            tipo: tipoTrabalhador,
            status,
            todos: true
        };

        this.RelatoriosService.baixarRelatorioFop(
            'persona_trabalhadores_ponto',
            constructor,
            callback,
            false,
            this.getFolhasPontoDownloadFileName()
        );

    }

    private resetEntityServiceState(): void {
        this.filter.search = '';
        this.filters = {};
        this.entityService.filter = '';
        this.entityService.filters = {};
        this.entityService.constructors = {};
    }

    private hydrateDefaults(): void {
        this.montaListagemVisibilidade();
        this.filter.search = '';
        this.trabalhadorinput = '';
        this.filters.tipo = this.getRouteDefaultFilter('tipo', '-1');
        this.filters.status = this.getRouteDefaultFilter('status', '00');
        this.filters.lotacao = null;
        this.filters.trabalhador = null;
    }

    private hydrateFromReturnContext(): void {
        const returnContext = this.getReturnContext();

        if (!returnContext) {
            return;
        }

        this.filter.search = returnContext.search || '';

        if (returnContext.empresa !== undefined) {
            this.filters.empresa = returnContext.empresa;
        }

        this.estabelecimentos = this.filters.empresa
            ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao)
            : [];

        if (returnContext.estabelecimento !== undefined) {
            this.filters.estabelecimento = returnContext.estabelecimento;
        }

        if (returnContext.tipo !== undefined) {
            this.filters.tipo = returnContext.tipo;
        }

        if (returnContext.status !== undefined) {
            this.filters.status = returnContext.status;
        }

        this.filters.lotacao = returnContext.lotacao ? angular.copy(returnContext.lotacao) : null;
        this.filters.trabalhador = returnContext.trabalhador ? angular.copy(returnContext.trabalhador) : null;
        this.trabalhadorinput = this.filters.trabalhador?.nome || '';
    }

    private applyFiltersToService(): void {
        this.entityService.filter = this.filter.search || '';
        this.entityService.filters = {};
        this.entityService.constructors = {};

        this.entityService.constructors['empresa'] = this.filters.empresa;
        this.entityService.constructors['estabelecimento'] = this.filters.estabelecimento;
        this.entityService.constructors['tipo'] = this.filters.tipo !== null && this.filters.tipo !== undefined ? this.filters.tipo : this.getRouteDefaultFilter('tipo', '-1');

        if (this.filters.status !== null && this.filters.status !== undefined && this.filters.status !== '') {
            this.entityService.constructors['status'] = this.filters.status;
        } else if (this.filters.status === null || this.filters.status === undefined) {
            this.entityService.constructors['status'] = this.getRouteDefaultFilter('status', '00');
        }

        if (this.filters.lotacao?.lotacao) {
            this.entityService.constructors['lotacao'] = this.filters.lotacao.lotacao;
        }

        if (this.filters.trabalhador?.trabalhador) {
            this.entityService.constructors['trabalhador'] = this.filters.trabalhador.trabalhador;
        }
    }

    private buildReturnContext(): ITrabalhadoresReturnContext {
        return {
            search: this.filter.search || '',
            empresa: this.filters.empresa ?? null,
            estabelecimento: this.filters.estabelecimento ?? null,
            tipo: this.filters.tipo !== null && this.filters.tipo !== undefined ? this.filters.tipo : this.getRouteDefaultFilter('tipo', '-1'),
            status: this.filters.status !== null && this.filters.status !== undefined ? this.filters.status : this.getRouteDefaultFilter('status', '00'),
            lotacao: this.filters.lotacao ? angular.copy(this.filters.lotacao) : null,
            trabalhador: this.filters.trabalhador ? angular.copy(this.filters.trabalhador) : null
        };
    }

    private refreshList(): ITrabalhadorListItem[] {
        return this.reloadEntities();
    }

    private reloadEntities(): ITrabalhadorListItem[] {
        this.applyFiltersToService();
        this.entities = this.entityService.reload() as ITrabalhadorListItem[];

        return this.entities;
    }

    private getReturnContext(): ITrabalhadoresReturnContext | null {
        const returnContext = this.$stateParams['returnContext'];

        if (!returnContext || typeof returnContext !== 'object') {
            return null;
        }

        return angular.copy(returnContext) as ITrabalhadoresReturnContext;
    }

    private getRouteDefaultFilter(paramName: 'tipo' | 'status', fallback: string): string {
        const value = this.$stateParams[paramName];

        return value !== undefined && value !== null && value !== ''
            ? String(value)
            : fallback;
    }

    private getFolhasPontoDownloadFileName(): string {
        const dataInicial = moment(this.dataInicial).format('DD-MM-YYYY');
        const dataFinal = moment(this.dataFinal).format('DD-MM-YYYY');

        return `folhas_de_ponto_${dataInicial}_a_${dataFinal}.pdf`;
    }

    private validarPeriodoRelatorioPonto(): boolean {
        if (this.dataInicial === null || this.dataFinal === null || this.dataInicial === '' || this.dataFinal === '') {
            this.NewToaster.pop({
                type: 'error',
                title: 'A data inicial/final do ponto não pode ser vazia'
            });

            return false;
        }

        const dataInicial = moment(this.dataInicial);
        const dataFinal = moment(this.dataFinal);

        if (!dataInicial.isBefore(dataFinal, 'day')) {
            this.NewToaster.pop({
                type: 'error',
                title: 'A data inicial do ponto não pode ser igual ou posterior a data final do ponto'
            });

            return false;
        }

        return true;
    }
}
